import React, { forwardRef, HTMLAttributes, memo, ReactNode } from 'react';
import classNames from 'classnames';
import pascalcase from 'pascalcase';
import * as SvgIcon from './svg-icons';
import * as DuoToneIcon from './duotone';
import * as HeroIcon from './heroicons';
import { textColor } from '../../utils/textColor.util';

const RefWrapper = forwardRef(({ children }, ref) => {
	if (ref) {
		return (
			<span ref={ref} data-only-ref='true'>
				{children}
			</span>
		);
	}
	return children;
});
RefWrapper.displayName = 'RefWrapper';

const Icon = forwardRef((props, ref) => {
	const { icon, className, color, colorIntensity, size, ...rest } = props;
	const IconName = pascalcase(icon);

	const SvgIconWrapper = SvgIcon[IconName];
	const DuoToneWrapper = DuoToneIcon[IconName];
	const HeroWrapper = HeroIcon[IconName];

	const CLASS_NAMES = classNames(
		'svg-icon',
		{ [`${size}`]: typeof size !== 'undefined' },
		textColor(color, colorIntensity),
		className,
	);

	if (typeof SvgIconWrapper === 'function') {
		return (
			<RefWrapper ref={ref}>
				<SvgIconWrapper
					data-component-name='Icon-A'
					data-name={`SvgIcon--${IconName}`}
					className={CLASS_NAMES}
					{...rest}
				/>
			</RefWrapper>
		);
	}
	if (typeof DuoToneWrapper === 'function') {
		return (
			<RefWrapper ref={ref}>
				<DuoToneWrapper
					data-component-name='Icon-B'
					data-name={`Duotone--${icon}`}
					className={CLASS_NAMES}
					{...rest}
				/>
			</RefWrapper>
		);
	}
	if (typeof HeroWrapper === 'function') {
		return (
			<RefWrapper ref={ref}>
				<HeroWrapper
					data-component-name='Icon-C'
					data-name={`Hero--${icon}`}
					className={CLASS_NAMES}
					{...rest}
				/>
			</RefWrapper>
		);
	}
	return null;
});
Icon.displayName = 'Icon';

export default memo(Icon);
